import { Label, Paragraph, Radio } from '@zillow/constellation-10';
import { WizardLabeledControl } from '../../styles/wizard';

const radioControlName = 'isApplicationsAccepted';

type Props = {
  onChange: (event: React.ChangeEvent) => void;
  isApplicationsAccepted: string;
};

export const ApplicationsLabeledControl = ({ isApplicationsAccepted, onChange }: Props) => {
  return (
    <>
      <WizardLabeledControl
        controlId="yes"
        label={
          <Label>
            <Paragraph textStyle="body-bold">Yes (most common)</Paragraph>
            <Paragraph textStyle="body-sm">Receive Zillow applications for free</Paragraph>
          </Label>
        }
        control={
          <Radio name={radioControlName} value="true" checked={isApplicationsAccepted === 'true'} onChange={onChange} />
        }
      />
      <WizardLabeledControl
        controlId="no"
        label={
          <Label>
            <Paragraph textStyle="body-bold">No</Paragraph>
            <Paragraph textStyle="body-sm">Don&apos;t receive Zillow applications</Paragraph>
          </Label>
        }
        control={
          <Radio
            name={radioControlName}
            value="false"
            checked={isApplicationsAccepted === 'false'}
            onChange={onChange}
            data-testid="decline-applications-checkbox"
          />
        }
      />
    </>
  );
};
